export default __webpack_public_path__ + "static/media/filter-icon.bb1bfe1a.svg";